/** 与后端 SubjectResourceType 枚举一致 */
export const SubjectResourceType = {
  Unknown: 0,
  Manuscript: 1,
  Document: 2,
  Video: 3,
  Audio: 4,
  Image: 5,
  Archive: 6,
  RichText: 7,
  Link: 8,
  ResourceGroup: 9,
  Course: 10,
  EBook: 11,
  LooseleafOrTextbook: 12,
  QuestionBank: 13,
  Other: 99,
};

/** robot 仅展示 2–8 类资源 */
export const ROBOT_SUPPORTED_RESOURCE_TYPES = new Set([2, 3, 4, 5, 6, 7, 8]);

export function parseSubjectResourceType(raw) {
  const n = typeof raw === "number" ? raw : Number(String(raw ?? "").trim());
  if (!Number.isFinite(n)) return SubjectResourceType.Unknown;
  return n;
}

export function isRobotSupportedResourceType(type) {
  return ROBOT_SUPPORTED_RESOURCE_TYPES.has(type);
}

export function isInlineMediaResourceType(type) {
  return (
    type === SubjectResourceType.Video ||
    type === SubjectResourceType.Audio ||
    type === SubjectResourceType.Image
  );
}

export function isInlineRichTextResourceType(type) {
  return type === SubjectResourceType.RichText;
}

export function isNavigableResourceType(type) {
  return (
    type === SubjectResourceType.Document ||
    type === SubjectResourceType.Link ||
    type === SubjectResourceType.Archive
  );
}
